import {
	Box,
	Button,
}
from '@mui/material';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';

function BlockEditFooter({ onDone, onCancel }) {
	return (
        <Box
            display="flex"
            flexDirection="row"
            style={{width:'100%',padding:10}}
            justifyContent="flex-end"
            alignItems="center"
        >
            <Button
                color="primary"
                endIcon={<ArrowRightIcon />}
                size="large"
                variant="contained"
                onClick={e => onCancel()}
            >
                Cancel
            </Button>
            <Button
                color="primary"
                endIcon={<ArrowRightIcon />}
                size="large"
                variant="contained"
                onClick={e => onDone()}
                sx={{marginLeft: 1}}
            >
                Done
            </Button>
        </Box>
	);
}

export default BlockEditFooter;
